function setRem () {
    // 基准大小
    const baseSize = 100;
    const baseScale = baseSize / 1366; // 1920的设计图
    let widthScale = window.innerWidth; // 当前窗口的宽度
    const heightScale = window.innerHeight; // 当前窗口的高度
    // 尺寸换算(移动端的横屏竖屏)
    // const comparedHeight = (widthScale * 1080) / 1920;
    // if (heightScale < comparedHeight) {
    //     widthScale = (heightScale * 1920) / 1080;
    // }
    // 计算实际的rem值,得到该宽度下的相应font-size值,并赋予给html的font-size,
    const rem = widthScale * baseScale;
    document.documentElement.style.fontSize = rem + "px";
    // 以下解决屏幕缩小时，背景图片的宽度只有一部分（不知道会不会造成其他影响）
    let min = 10000 / rem;
    document.documentElement.style.width = (min < 100 ? 100 : min) + "%";
}
setRem()

window.addEventListener("resize", () => {
    setRem()
})